import React, { useState } from 'react';
import { dispositionsAPI } from '../../services/api';
import toast from 'react-hot-toast';

// Qo'ng'iroq natijasini belgilash uchun ixcham tanlagich.
// props: call (id, outcome_code_id, outcome_color), codes [], onChanged()
export default function OutcomeSelect({ call, codes, onChanged }) {
  const [value, setValue] = useState(call.outcome_code_id || '');
  const [saving, setSaving] = useState(false);

  const current = codes.find(c => c.id === Number(value));

  const change = async (e) => {
    const code_id = e.target.value;
    if (!code_id) return;
    setValue(code_id);
    setSaving(true);
    try {
      await dispositionsAPI.setOutcome({ call_record_id: call.id, code_id: Number(code_id) });
      toast.success('Natija saqlandi');
      if (onChanged) onChanged();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Xato');
      setValue(call.outcome_code_id || '');
    } finally {
      setSaving(false);
    }
  };

  return (
    <select
      value={value}
      onChange={change}
      disabled={saving}
      title="Qo'ng'iroq natijasi"
      style={{
        fontFamily: 'inherit', fontSize: 12, fontWeight: 600, cursor: 'pointer',
        padding: '5px 8px', borderRadius: 8,
        background: 'var(--bg-primary, #0f172a)',
        color: current ? current.color : 'var(--text-muted)',
        border: `1px solid ${current ? current.color : 'var(--border, #2d3a4f)'}`,
        maxWidth: 150,
      }}
    >
      <option value="" style={{ color: 'var(--text-muted)' }}>— natija —</option>
      {codes.map(c => (
        <option key={c.id} value={c.id} style={{ color: 'var(--text-primary)' }}>{c.name}</option>
      ))}
    </select>
  );
}
